module.exports = __webpack_public_path__ + "static/media/2_MACDONALDS.456cabfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_mcdonalds/2_MACDONALDS.jpg
// module id = 1163
// module chunks = 37